import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { ArrivalStatus, TripStatus } from '@asset-solutions/customer-portal/orders/models';

@Component({
  selector: 'orders-trip-status-pill',
  templateUrl: './trip-status-pill.component.html',
  styleUrls: ['./trip-status-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TripStatusPillComponent {
  @Input() tripStatus!: TripStatus;
  @Input() arrivalStatus!: ArrivalStatus;
}
